import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, unref as _unref, createElementVNode as _createElementVNode, createVNode as _createVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-fa411fc6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "create-namespace-drawer" }
const _hoisted_2 = { class: "create-namespace-drawer__header" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "create-namespace-drawer__title-block" }, [
  /*#__PURE__*/_createElementVNode("h2", { class: "create-namespace-drawer__title" }, "Новая рабочая область")
], -1))
const _hoisted_4 = { class: "create-namespace-drawer__main" }

import { onMounted, onUnmounted, Ref, ref, watch } from 'vue';
import {
  TirPmButton,
  TirPmButtonSizeEnum,
  TirPmButtonVariantEnum,
  TirPmDrawer,
  TirPmDrawerPositionEnum,
  TirPmStatusBudge,
  TirPmTooltipElementPlacementEnum,
  TirPmTooltipElement,
} from 'tir-components';
import { CreateNamespaceForm, CreateNamespaceResultModel } from '../create-namespace-form';
import { CrossLinedIcon } from 'tir-style-system/icons/outline';


export default /*#__PURE__*/_defineComponent({
  __name: 'create-namespace-drawer',
  props: {
  /**ID проекта */
  projectId: {
    type: Number,
    required: true,
  },
},
  emits: ["onCreate"],
  setup(__props, { expose: __expose, emit }) {





/**Состояние видимости TooltipElement */
const tooltipElementVisibleState: Ref<boolean> = ref();

/**Видимость tir-pm-drawer */
const visible = ref(false);

watch(
  () => visible.value,
  () => {
    if (!visible.value) tooltipElementVisibleState.value = false;
  },
);

const open = () => (visible.value = true);

/**изменение видимости TooltipElement */
const changeVisibilityTooltipElement = (value) => {
  tooltipElementVisibleState.value = value;
};

const onCreate = (value: CreateNamespaceResultModel) => {
  emit('onCreate', value);
  visible.value = false;
};

__expose({
  open,
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _renderSlot(_ctx.$slots, "default", { open: open }),
    _createVNode(_unref(TirPmDrawer), {
      visible: visible.value,
      "onUpdate:visible": _cache[0] || (_cache[0] = ($event: any) => ((visible).value = $event)),
      size: "51.875rem",
      position: _unref(TirPmDrawerPositionEnum).Right
    }, {
      content: _withCtx(({ close }) => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _hoisted_3,
            _createVNode(_unref(TirPmButton), {
              variant: _unref(TirPmButtonVariantEnum).LinkState,
              size: _unref(TirPmButtonSizeEnum).Regular,
              onClick: close
            }, {
              leftSlot: _withCtx(() => [
                _createVNode(_unref(CrossLinedIcon))
              ]),
              _: 2
            }, 1032, ["variant", "size", "onClick"])
          ]),
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_unref(CreateNamespaceForm), {
              "project-id": __props.projectId,
              onOnCreate: onCreate,
              onOnCancel: close,
              onTooltipElementVisibleState: changeVisibilityTooltipElement
            }, null, 8, ["project-id", "onOnCancel"])
          ])
        ])
      ]),
      _: 1
    }, 8, ["visible", "position"])
  ], 64))
}
}

})